/// <reference types="vite-plugin-svgr/client" />
import { Box, Container, Grid, Link as MuiLink, Button, Typography } from '@mui/material';

import Logo from '~/assets/images/logo-black.svg?react';
import Fallback from '~/assets/images/fallback.svg?react';

export default function FallbackNoRouterElement() {
  console.log('fallback no router');

  const handleLoginClick = () => {
    window.location.href = '/';
  };

  return (
    <Box sx={{ backgroundColor: 'background.default' }}>
      <Grid container sx={{ minHeight: '100vh' }}>
        <Grid item xs={6}>
          <Box
            sx={{
              maxWidth: {
                xs: 350,
                lg: 400,
              },
              minHeight: '100vh',
              display: 'grid',
              alignItems: 'space-between',
              py: 3.75,
              m: 'auto',
            }}>
            {/* Logo */}
            <MuiLink href="/" sx={{ width: 116, display: 'inline-block' }}>
              <Logo />
            </MuiLink>

            {/* <>dddd</> */}

            <Box>
              <Typography
                variant="h1"
                sx={{ mb: 1, fontSize: '1.4em', color: 'text.primary', marginTop: 'auto', textWrap: 'pretty' }}>
                Sorry, our muscles are overloaded
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', textWrap: 'pretty' }}>
                Please try to log back in and reach out if the issues continues.
              </Typography>
              <Button
                variant="contained"
                size="large"
                sx={{
                  mt: 2,
                  textTransform: 'none',
                  p: 1.5,
                }}
                fullWidth
                onClick={handleLoginClick}>
                Log In
              </Button>
            </Box>
          </Box>
        </Grid>
        {/* /Login form wrapper */}

        {/* Login image */}
        <Grid item xs={6}>
          <Box
            sx={{
              height: '100vh',
              backgroundColor: '#F6F7FB',
              //   backgroundImage: `url(${BackgroundImage})`,
              backgroundSize: 'cover',
            }}>
            <Container
              sx={{
                maxWidth: { xs: 380 },
                px: { xs: 0 },
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                backgroundColor: 'rgba(0, 0, 0, 0)',
              }}>
              <Fallback />
            </Container>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
